






import Vue from 'vue';

/**
 * A Stack stacks all its children on top of the other
 * and selects which one is visible using the active property.
 * It's named after StackLayout in SWT.
 */
export default Vue.extend({
  name: 'Stack',
  beforeMount() {
    this.refreshClass();
  },
  beforeUpdate() {
    this.refreshClass();
  },
  props: {
    active: {
      type: String,
    },
  },
  methods: {
    refreshClass() {
      if (this.$slots.default) {
        this.$slots.default.filter((obj) => null != obj.tag).forEach((obj) => {
          const isActive = this.$props.active === (obj.data && obj.data.attrs && obj.data.attrs.id);
          const oldClass = (obj.data && obj.data.staticClass) || '';
          const classes = oldClass.split(/\S+/g);
          const newClass = classes.filter((v) => 'active' !== v).concat(isActive ? ['active'] : []).join(' ');
          if (obj.data) {
            obj.data.staticClass = newClass;
          } else {
            obj.data = { staticClass: newClass };
          }
        }, this);
      }
    },
  },
});
